<template lang="pug">
  .gvl-inputs
    //p.my-1 <b>Eine sehr wichtige Information vorweg:</b> Bitte beachten Sie, dass eine Zwischenspeicherung Ihrer eingegebenen Daten nicht möglich ist! Die Eingabe Ihrer Daten sowie das Hochladen der erforderlichen Nachweise muss in einem Schritt erfolgen und endet mit dem Schritt „Antrag absenden“.
    //p.my-1 <b>Wir empfehlen den gesamten Fragenkatalog in den FAQ vorab durchzusehen, sodass Sie die notwendigen Dokumente bereithalten können.</b>
    //p.mt-1.mb-5 Berücksichtigen Sie bitte auch, dass es gerade zu Beginn des Stipendienprogramms zu längeren Bearbeitungszeiten kommen kann. Unsere Hotline steht von Montag bis Sonntag (6 bis 22 Uhr) unter der Rufnummer 0202-2515 57305 bereit.
    .notice-box Das Antragsportal wurde vorzeitig geschlossen, da die Mittel aufgrund der Anzahl an Anträgen bereits ausgeschöpft sind.

    template(v-if="inputsToken")
      p.my-1 Bitte beachten Sie, dass eine Zwischenspeicherung Ihrer eingegebenen Daten nicht möglich ist! Die Eingabe Ihrer Daten sowie das Hochladen der erforderlichen Nachweise muss in einem Schritt erfolgen und endet mit dem Schritt „Antrag absenden“.
      p.mb-3 Berücksichtigen Sie bitte auch, dass es gerade zu Beginn des Stipendienprogramms zu längeren Bearbeitungszeiten kommen kann.
      v-stepper(v-model="step")
        v-stepper-header
          v-stepper-step(
            complete
            step="1"
            @click="onSelectStep(1)"
          ) Daten erfassen

          v-stepper-step(
            :complete="completedStep >= 1"
            step="2"
          ) Antragsdaten prüfen

          v-stepper-step(
            step="3"
            :complete="completedStep >= 2"
          ) Abschluss

        v-stepper-items
          v-stepper-content.pa-0(step="1")
            input-data.mt-8(v-show="step === 1" ref="input-data" @next="onNextStep(1)")

          v-stepper-content.pa-0(step="2")
            p.hint-label.font-weight-bold.mt-3.mb-2 Achtung:
            p.hint-label.mb-0 Bitte prüfen Sie in der nachfolgenden Übersicht Ihre angegebenen Daten sorgfältig auf Korrektheit. Um Änderungen vorzunehmen, gelangen Sie mit einem Klick auf die orange Schaltfläche "Daten erfassen" zurück zur Datenerfassung.
            check-data.mt-8(v-if="step === 2" @next="onNextStep(2)" @file-error="onFileError")

          v-stepper-content.pa-0(step="3")
            thank-you.mt-8(v-if="step === 3")

</template>

<script>
import { Vue, Component } from 'vue-property-decorator'

import FormMixin from '@/mixins/form'

@Component({
  mixins: [
    FormMixin
  ],

  components: {
    InputData: () => import('@/components/input-data'),
    CheckData: () => import('@/components/check-data'),
    ThankYou: () => import('@/components/thank-you'),
  }
})
export default class Inputs extends Vue {
  step = 1
  completedStep = 0

  mounted () {
    if (this.isFinished) {
      this.gotoRoute('home')
    }

    // console.log(this.$route.query)
    if (this.$route.query.show_form === '1' && this.$route.query.token) {
      this.$store.dispatch('setToken', this.$route.query.token)
    } else {
      this.$store.dispatch('setToken', null)
    }
  }

  onFileError () {
    this.step = 1
    const inputData = this.$refs['input-data']
    if (inputData) {
      inputData.onCheckInfo()
    }
  }

  onSelectStep (id) {
    if (this.step !== 2) {
      return
    }
    this.step = 1
    this.completedStep = 0
    this.resetScroll()
    // this.step = id
    // this.resetScroll()
  }

  onNextStep (id) {
    this.completedStep = id
    this.step = id + 1
    this.resetScroll()
  }

  resetScroll () {
    window.scrollTo(0, 0)
  }
}
</script>

<style lang="sass">
.gvl-inputs
  width: 100%

  .v-stepper,
  .v-stepper__header
    box-shadow: none !important

  .v-stepper__header
    height: 60px

  .v-stepper__step__step
    min-height: 0
    height: auto

  .v-stepper__step
    position: relative
    background-color: #999
    flex: 1 1 33%
    justify-content: center
    max-width: 33%
    overflow: visible
    padding: 0
    padding-left: 30px
    pointer-events: none

    &:before,
    &:after
      content: ""
      position: absolute
      top: 0
      border-style: solid
      border-width: 31px 0 31px 31px
      width: 0
      height: 0

    &:before
      left: -1px
      border-color: transparent transparent transparent #fff

    &:after
      right: -1px
      border-color: #fff #fff #fff transparent
      z-index: 2

    .v-stepper__step__step
      display: none

    .v-stepper__label
      color: #fff !important
      font-size: 18px
      font-weight: 500
      text-shadow: none !important

    &--active,
    &--complete
      cursor: pointer
      pointer-events: all

    &--complete
      background-color: #F88D22
</style>
